module.exports = __webpack_public_path__ + "static/media/galerija_2021 (24)-min.50418887.jpg";